import React from 'react'
import { observer } from 'mobx-react'
import { WorkspacePostingForm } from '../WorkspacePostingDialog'
import CreateWorkspacePostingViewModel from './CreateWorkspacePostingViewModel'

interface CreateWorkspacePostingDialogProps {
  vm: CreateWorkspacePostingViewModel
}

export default observer(function CreateWorkspacePostingDialog({
  vm,
}: CreateWorkspacePostingDialogProps) {
  return (
    <WorkspacePostingForm vm={vm} title="New post" buttonText="Create Post" />
  )
})
